import {Component, Input} from '@angular/core';
import {NgClass, NgForOf, NgIf, NgStyle, NgTemplateOutlet} from "@angular/common";
import {RouterLink, RouterLinkActive} from "@angular/router";
import {MenuItem} from "primeng/api";
import {animate, state, style, transition, trigger} from "@angular/animations";

@Component({
  selector: 'app-navbar-gov-co',
  standalone: true,
  imports: [
    NgForOf,
    RouterLinkActive,
    RouterLink,
    NgStyle,
    NgTemplateOutlet,
    NgIf,
    NgClass
  ],
  template: `
    <nav class="flex justify-content-between">
    <ul class=" lg:my-0 width-container">
      <li *ngFor="let navItem of menuItems"  role="menuitem" [ngStyle]="navItem.style">
        <ng-container *ngTemplateOutlet="template; context: {obj: navItem}"></ng-container>
      </li>
    </ul>
  </nav>

  <ng-template #template let-item="obj">
    <div  class="flex item-nav"  routerLinkActive="active-link"  [routerLinkActiveOptions]="{exact: true}"
          [ngClass]="{'justify-content-between align-items-center': item.items}">
      <a [routerLink]="item.routerLink"  class="no-underline w-full">
        <span> {{ item.label }}</span>
      </a>
      <a (click)="toggle(item, $event)" *ngIf="item.items">
        <i class="pi app-text-gray"
           [ngClass]="item.toggle ? 'pi-angle-up' : 'pi-angle-down'"></i>
      </a>
    </div>
    <hr class="seperator" role="separator">

    @if (item.items) {
      <div class="ml-2 content-subitem" [@subitems]="item.toggle ? 'visibleAnimated' : 'hiddenAnimated'">
      <ul class=" lg:my-0 width-container">
          <li *ngFor="let navItem of item.items" role="menuitem" [ngStyle]="navItem.style" style="">
            <ng-container *ngTemplateOutlet="template; context: {obj: navItem}"></ng-container>
          </li>
        </ul>
      </div>
    }
  </ng-template>`,
  animations: [
    trigger('subitems', [
      state('void', style({
        height: '0px'
      })),
      state('hiddenAnimated', style({
        visibility: 'hidden',
        height: '0px'
      })),
      state('visibleAnimated', style({
        visibility: 'visible',
        height: '*'
      })),
     /* state('visible', style({
        height: '*',
        'z-index': 100
      })),
      state('hidden', style({
        height: '0px',
        'z-index': '*'
      })),*/
      transition('visibleAnimated => hiddenAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
      transition('hiddenAnimated => visibleAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
      transition('void => visibleAnimated, visibleAnimated => void',
        animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
    ])
  ],
  styleUrl: './navbar-gov-co.component.scss'
})
export class NavbarGovCoComponent {
  @Input({required: true}) menuItems: MenuItem[] | undefined;

  toggle(item: any, $event: any) {
    console.log($event);
    item.toggle = !item.toggle;
  }

}
